import { GridProps } from '@mui/material/Grid/Grid';
import { Option } from '../inputs/option';

type InputProps = {
  schema?: any
  hidden?: boolean
  gridProps?: GridProps
  inputType?: InputType
  remote?: string
  options?: Option[] | string[],
  defaultValue?:any
  [key: string]: any;
};

export interface IColumn {
  name: string
  label: string
  inputProps?: InputProps
  tableProps?:{
    render?: (value: any, row?: any) => any
    cellProps?: any,
    [key: string]: any
  }
}

export enum InputType {
  Number = 'Number',
  Text = 'Text',
  TextField = 'TextField',
  Select = 'Select',
  Date = 'Date',
  TextArea = 'TextArea',
  RemoteSelect = 'RemoteSelect',
  Radio = 'Radio',
  CheckBox = 'CheckBox',
  Switch = 'Switch',
  Password = 'Password',
}

export const isComboField = (field:IColumn) => field.inputProps?.inputType === InputType.Select || field.inputProps?.inputType === InputType.RemoteSelect;
